import { Format } from "@/helpers/formatHelper";

type IOSWindow = Window & {
    webkit?: {
        messageHandlers?: {
            jsHandler?: {
                postMessage: (message: string, targetOrigin: string) => void;
            };
        };
    };
};

export class AppsHelper {

    static isSafari(): boolean {
        return /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
        );
    }

    static isAndroidWebView(): boolean {
        return /Android/.test(navigator.userAgent) && /Version\/[\d.]+/.test(navigator.userAgent);
    }

    static isIOSWebView(): boolean {
        const webview = localStorage.getItem("webview");
        if (webview) {
            return true;
        }
        return false;
    }

    static isSafariOrIosWebView(): boolean {
        return AppsHelper.isSafari() || AppsHelper.isIOSWebView();
    }

    static sendToIOS(targetWindow: IOSWindow, jsonData: unknown): boolean {
        if (!this.isIOSWebView()) {
            return false;
        }

        const handler = targetWindow.webkit?.messageHandlers?.jsHandler;
        if (handler && typeof handler.postMessage === "function") {
            handler.postMessage(JSON.stringify(jsonData), "*");
            // TODO: Replace '*' with the market.com origin once available in production.
            return true;
        }

        return false;
    }

    static isWebView(): boolean {
        return AppsHelper.isAndroidWebView() || AppsHelper.isIOSWebView();
    }
}

export function isDeviceVeryOld(): boolean {
    return Format.IsNull(navigator) || Format.IsNull(navigator.clipboard);
}
